import dayjs from 'dayjs'
import * as Actions from '../../../../Modules/CmsActions'
import type { IPagination } from '../../../../Types'
import type {
  FormClientRecaptcha,
  FormExternalUrl,
} from '../../../../Types/Api/Form'

export type FormUser = {
  id: number
  form_id: number
  user_id: number
  email: string
  is_send: boolean
}

interface State {
  loading: boolean
  list: any
  edit: null | any
  editScript: FormExternalUrl | null
  clientRecaptcha: FormClientRecaptcha | null
  pagination: IPagination
  users: FormUser[]
  saving: boolean
}

const initialState: State = {
  loading: false,
  edit: null,
  editScript: null,
  clientRecaptcha: {
    client_secret_key: '',
    server_secret_key: '',
  },
  list: [],
  pagination: {
    current_page: 1,
    first_page_url: null,
    from: 1,
    last_page: 1,
    last_page_url: null,
    next_page_url: null,
    path: null,
    per_page: 1,
    prev_page_url: null,
    to: 1,
    total: 1,
  },
  users: [],
  saving: false,
}

const UIFormReducer = (state = initialState, action) => {
  const { type, payload, error } = action

  switch (action.type) {
    case Actions.REQUEST_FINISH_ALL_FORMS:
      return { ...state, loading: true }

    case Actions.FINISH_FETCH_ALL_FORMS:
    case Actions.LOADED_INITIAL_SITE_VALUES:
    case Actions.SELECT_SITE:
      return error
        ? { ...state, loading: false }
        : {
            ...state,
            loading: false,
            list: Array.isArray(payload.forms)
              ? payload.forms.map(
                  ({
                    id,
                    title,
                    document,
                    name,
                    public: isPublic,
                    user_reply_flag,
                    updated_at,
                  }) => ({
                    id,
                    title: title,
                    document,
                    name,
                    isPublic,
                    updated_at: dayjs(updated_at),
                    user_reply_flag,
                  }),
                )
              : [],
            pagination: payload.pagination,
          }

    case Actions.REQUEST_FETCH_FORM:
      return { ...state, loading: true }

    case Actions.FINISH_FETCH_FORM:
      return {
        ...state,
        loading: false,
        edit: payload.form,
        users: payload.form.users,
      }

    case Actions.UNLOAD_FORM:
      return { ...state, edit: null }

    case Actions.REQUEST_UPDATE_FORM:
      return { ...state, saving: true }

    case Actions.FINISH_UPDATE_FORM:
      return { ...state, saving: false }

    case Actions.REQUEST_SEARCH_EXTERNALURLS:
      return { ...state, scriptLoading: true }

    case Actions.FINISH_SEARCH_EXTERNALURLS:
      return { ...state, scriptLoading: false, editScript: payload.editScript }

    case Actions.UNLOAD_EXTERNALURLS:
      return { ...state, editScript: null }

    case Actions.REQUEST_SEARCH_CLIENTRECAPTCHA:
      return { ...state, scriptLoading: true }

    case Actions.FINISH_SEARCH_CLIENTRECAPTCHA:
      return {
        ...state,
        scriptLoading: false,
        clientRecaptcha: {
          client_secret_key: payload.clientRecaptcha.client_secret_key,
          server_secret_key: payload.clientRecaptcha.server_secret_key,
        },
      }

    case Actions.REQUEST_FETCH_FORM_USER:
      return { ...state, users: payload }

    case Actions.CLEAR_FETCH_FORM_USER:
      return { ...state, users: [] }

    case Actions.ADD_FORM_USER:
      return {
        ...state,
        users: [
          ...state.users,
          {
            id: 0,
            form_id: state.users[0].form_id,
            user_id: null,
            email: '',
            is_send: false,
          },
        ],
      }

    case Actions.FIX_FORM_USER_MAIL:
      return {
        ...state,
        users: state.users.map((user, index) =>
          index === action.payload.index
            ? { ...user, email: action.payload.value }
            : user,
        ),
      }

    case Actions.DELETE_FORM_INPUT:
      return {
        ...state,
        users: state.users.filter((el, i) => {
          return i != action.payload
        }),
      }

    case Actions.CHANGE_FORM_USER_CHECK:
      return {
        ...state,
        users: state.users.map((user, index) =>
          index === action.payload.index
            ? { ...user, is_send: action.payload.value }
            : user,
        ),
      }

    case Actions.DELETE_FORM_USER:
      return {
        ...state,
        users: state.users.filter((el) => {
          return el.id != action.payload
        }),
      }

    default:
      return state
  }
}

function loaded(state) {
  return { ...state, loading: false }
}

export default UIFormReducer
